import React from 'react';
import classnames from 'classnames';
import { checkString, checkArray } from '../helpers/global'

const Combi = props => {

  const {data} = props;
  let img_src = "";
  let img_alt = "";
  let focal_point = "";
  let combiStyle = {};
  if (checkArray(data.image_data)){
    img_src = data.image_data.toString();
  }
  if (!img_src) {
    img_src = data.image_url;
  }
  img_alt = data.image_alt;

  if (checkArray(data.focal_point)){
    focal_point = data.focal_point;
     combiStyle = {
      objectPosition: focal_point[0] + "%" + " " + focal_point[1] + "%"
    }
  }



  return (
    <>
    <div className="grid-item cta-slot">
      <a href={data.url}   className="slot">
      {checkString(img_src) &&
        <div className="slot-image">
         <a className="image-container" target={checkString(data.yc_foreign_id) ? '_blank' : '_self'}  href={data.url} >
             <img loading="lazy" srcset={img_src}  alt={img_alt} style={combiStyle} />
          </a>
        </div>
      }
      <div className="slot-content-outer">


      <div className="slot-content">

      <div className="slot-content-inner">


          {checkString(data.title) &&
            <div className="slot-title font-bold font-m" dangerouslySetInnerHTML={{__html: data.title}} />
          }
          {checkString(data.text) &&
            <div className="slot-text">{data.text}</div>
          }
          <div className="button">
          {data.link_title}
          <svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.28564 4.5L8.71422 9.5L2.28564 14.5" stroke="white" strokeWidth="2" strokeLinecap="square"></path>
                  </svg>
          </div>

      </div>
      </div>
      </div>



      </a>
    </div>

    </>
  )
}

export default Combi;
